import elementComputed from './computeds/element';
import store from '@/store/index';

export default {
  computed: {
    userInfo() {
      return store.state.userInfo;
    },
    companyId() {
      return store.getters.companyId;
    },
    // 是否系统管理员
    // isAdmin () {
    //     return store.getters.isAdmin
    // },
    ...elementComputed,
  },
};
